<template>
  <div
    :class="{
      'project-note-empty': notes.length === 0,
      empty: notes.length === 0,
    }"
  >
    <div class="project-note-header header">
      <h4>
        Notatki ({{ notes.length }})
        <button
          class="btn"
          @click="toggleList = !toggleList"
          :class="{ active: !toggleList }"
        >
          <i class="fas fa-chevron-down"></i>
        </button>
      </h4>
    </div>
    <div v-if="toggleList" class="project-note-list">
      <div v-if="notes.length === 0">
        <i class="empty-state far fa-sticky-note"></i>
        <span class="empty-search">Brak notatek</span>
      </div>
      <div v-else>
        <div class="project-note" v-for="(note, index) in notes" :key="index">
          <div class="project-note-content">
            <div class="project-note-title">
              <h5>{{ note.fullname }}</h5>
              <span>{{ note.created_at | date }}</span>
            </div>

            <p>{{ note.content }}</p>
          </div>
          <b-dropdown
            no-caret
            right
            variant="light"
            class="btn-rounded"
            v-if="showOptions(note)"
          >
            <template v-slot:button-content>
              <i class="fas fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item-button @click="showModal(note)"
              >Edytuj</b-dropdown-item-button
            >
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item-button class="danger" @click="remove(index)">
              <i class="fas fa-trash-alt"></i> Usuń
            </b-dropdown-item-button>
          </b-dropdown>
        </div>
      </div>
    </div>
    <NotesModalForm
      :note="selected"
      :constructionid="constructionid"
      v-on:onSubmit="this.handleAppendItem"
      v-on:onClose="clean"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NotesModalForm from "@/components/notes/NotesModalForm";
import notesService from "@/services/notes.service";
import dayjs from "dayjs";
import {formatDateOnly} from "@/services/helpers";

export default {
  name: "NotesPortlet",
  components: { NotesModalForm },
  props: {
    notes: { type: Array },
    constructionid: { type: Number },
  },
  data() {
    return {
      selected: {},
      toggleList: true,
    };
  },
  filters: {
    date(value) {
      return formatDateOnly(value, "YYYY-MM-DD");
    }
  },
  computed: {
    ...mapGetters("user", ["getRole"]),
  },
  methods: {
    showModal(note) {
      this.selected = {};
      if (note) {
        this.selected = note;
      }
      this.$nextTick(() => {
        this.$bvModal.show("notesForm-modal");
      });
    },
    handleAppendItem(note) {
      if (note) {
        this.notes.unshift(note);
      }
    },
    remove(noteIndex) {
      let note = this.notes[noteIndex],
        h = this.$createElement;
      this.$bvModal
        .msgBoxConfirm(
          [
            h("p", [
              "Czy na pewno chcesz usunąć wpis ",
              h("br"),
              h("br"),
              h("strong", note.fullname),
              " z dnia ",
              h(
                "strong",
                dayjs(note.created_at).format("YYYY-MM-DD HH:mm")
              ),
              " ?",
            ]),
          ],
          {
            title: "Potwierdź usunięcie notatki",
            okVariant: "danger",
            okTitle: "TAK",
            cancelTitle: "NIE",
          }
        )
        .then((result) => {
          if (result === true) {
            this.$Progress.start();
            notesService.delete(this.constructionid, note.id).then(() => {
              this.notes.splice(noteIndex, 1);
            });

            // this.remove();
          }
        });
    },
    showOptions(note) {
      if (note.owner === true) return true;
      if (note.isSubcontractor === true && this.getRole !== "subcontractor")
        return true;

      if (this.getRole === "admin" || this.getRole === "superadmin")
        return true;

      return false;
    },
    clean() {
      this.selected = {};
    },
  },
};
</script>
